var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.137 27.0069L20.3635 8.99815C19.526 7.59437 17.4748 7.59437 16.611 8.99815L5.86475 27.0069C5.00097 28.4644 6.05354 30.3006 7.72732 30.3006H29.2736C30.9748 30.3006 32.0282 28.4654 31.137 27.0069ZM17.367 15.9104C17.367 15.208 17.9345 14.6142 18.6632 14.6142C19.3657 14.6142 19.9595 15.1816 19.9595 15.9104V21.338C19.9595 22.0404 19.392 22.6342 18.6632 22.6342C17.9608 22.6342 17.367 22.0667 17.367 21.338V15.9104ZM18.6358 26.6556C17.907 26.6556 17.3396 26.0618 17.3396 25.3594C17.3396 24.6306 17.9334 24.0632 18.6358 24.0632C19.3646 24.0632 19.932 24.657 19.932 25.3594C19.932 26.0618 19.3646 26.6556 18.6358 26.6556Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationError);
export default __webpack_public_path__ + "static/media/notification-error.eb97b2a5971ecafe4c786c676f3f2962.svg";
export { ForwardRef as ReactComponent };